import { render, staticRenderFns } from "./AnnotationPolyline.vue?vue&type=template&id=4e5cdb63&scoped=true&"
import script from "./AnnotationPolyline.vue?vue&type=script&lang=js&"
export * from "./AnnotationPolyline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5cdb63",
  null
  
)

export default component.exports